
import { FaHome, FaRocketchat, FaUserTie, FaRoute, FaChartBar, FaFileInvoiceDollar } from "react-icons/fa";
import AreaDetailesPage from "./components/area/area-details";
import DiscountAreaDetailesPage from "./components/discount-areas/area-details";
import AreaForm from "./components/area/area-form";
import DiscountAreaForm from "./components/discount-areas/area-form";
import BannerClientDetailesPage from "./components/banners/banner-client/details";
import { default as BannerClientForm } from "./components/banners/banner-client/form";
import CategoryDetailsPage from "./components/category/category-details";
import CategoryForm from "./components/category/category-form";
import CityDetailesPage from "./components/city/city-details";
import CityForm from "./components/city/city-form";
import ClientDetailsPage from "./components/client/client-details";
import ClientForm from "./components/client/client-form";
import CommenQuestionDetailesPage from "./components/commen-question/commen-question-details";
import CommenQuestionForm from "./components/commen-question/commen-question-form";
import ComplaintDetailesPage from "./components/complaint/complaint-details";
import ComplaintForm from "./components/complaint/complaint-form";
import DeliveryWorkerDetailsPage from "./components/delivery-worker/delivery-worker-details";
import DeliveryWorkerForm from "./components/delivery-worker/delivery-worker-form";
import DriverClassificationDetailsPage from "./components/driver-classification/driver-classification-details";
import DriverClassificationForm from "./components/driver-classification/driver-classification-form";
import TripDetailsPage from "./components/trip/trip-details";
import TripForm from "./components/trip/trip-form";
import SkipReasonPage from "./pages/skip-reason";
import SkipReasonDetailsPage from "./components/skip-reason/skip-reason-details";
import SkipReasonForm from "./components/skip-reason/skip-reason-form";
import SkipAnalyticsPage from "./pages/skip-analytics";
import DriverHistoryPage from "./pages/skip-analytics/driver-history";
import PriceAuditPage from "./pages/price-audit";
import IncentiveDetailsPage from "./components/incentive/incentive-details";
import IncentiveForm from "./components/incentive/incentive-form";
import DiscountCodeDetailesPage from "./components/discount-code/discount-code-details";
import DiscountCodeForm from "./components/discount-code/discount-code-form";
import GeneralNotificationDetailesPage from "./components/general-notification/general-notification-details";
import GeneralNotificationForm from "./components/general-notification/general-notification-form";
import GeneralSettingDetailesPage from "./components/general-setting/general-setting-details";
import GeneralSettingForm from "./components/general-setting/general-settings-form";
import HomePageListDetailsPage from "./components/home-page-list/home-page-list-details";
import HomePageListForm from "./components/home-page-list/home-page-list-form";
import InvestorDetailesPage from "./components/investor/investor-details";
import InvestorForm from "./components/investor/investor-form";
import OrderNoteDetailesPage from "./components/order-note/order-note-details";
import OrderNoteForm from "./components/order-note/order-note-form";
import OrderDetailesPage from "./components/order/order-details";
import AddProductsToOrderPage from "./pages/order/add-products-to-order";
import PaymentDeliveryWorkerDetailesPage from "./components/payment-delivery-worker/details";
import PaymentDeliveryWorkerForm from "./components/payment-delivery-worker/form";
import PolicyTermDetailesPage from "./components/policy-term/policy-term-details";
import PolicyTermForm from "./components/policy-term/policy-term-form";
import ProductDetailesPage from "./components/product/product-details";
import ProductForm from "./components/product/product-form";
import RoleDetailesPage from "./components/role/role-details";
import RoleForm from "./components/role/role-form";
import StoreDetailesPage from "./components/store/store-details";
import StoreForm from "./components/store/store-form";
import TagDetailesPage from "./components/tag/tag-details";
import TagForm from "./components/tag/tag-form";
import TrademarkDetailsPage from "./components/trademark/trademark-details";
import TrademarkForm from "./components/trademark/trademark-form";
import UnitDetailesPage from "./components/unit/unit-details";
import UnitForm from "./components/unit/unit-form";
import UnitPartitionDetailesPage from "./components/unit-partition/unit-partition-details";
import UnitPartitionForm from "./components/unit-partition/unit-partition-form";
import UserDetailesPage from "./components/user/user-details";
import UserForm from "./components/user/user-form";
import AreaPage from "./pages/area";
import DiscountAreaPage from "./pages/discount-areas";
import AttributePage from "./pages/attribute";
import BannerClientPage from "./pages/banner/banner-client";
import CategoryPage from "./pages/categories";
import CityPage from "./pages/city";
import ClientPage from "./pages/client";
import CommenQuestionPage from "./pages/commen-question";
import ComplaintPage from "./pages/complaint";
import DeliveryWorkersPage from "./pages/delivery-worker";
import DriverClassificationPage from "./pages/driver-classification";
import TripPage from "./pages/trip";
import IncentivePage from "./pages/incentive";
import DiscountCodePage from "./pages/discount-code";
import GeneralNotificationPage from "./pages/general-notification";
import Home from "./pages/home";
import HomePageListPage from "./pages/home-page-list";
import InvestorPage from "./pages/investor";
import OrderPage from "./pages/order";
import OrderNotePage from "./pages/order-note";
import PaymentDeliveryWorkerPage from "./pages/payment-delivery-worker";
import RolePage from "./pages/role";
import StorePage from "./pages/store";
import TagPage from "./pages/tag";
import TrademarkPage from "./pages/trademark";
import UnitPage from "./pages/unit";
import UnitPartitionPage from "./pages/unit-partition";
import UserPage from "./pages/user";
import PublicSurveillance from "./pages/public-surveillance";
import PointPage from "./pages/point";
import PointForm from "./components/point/point-form";
import PointDetailsPage from "./components/point/point-details";
import PaymentPointPage from "./pages/payment-point";
import PaymentPointForm from "./components/payment-point/payment-point-form";
import PaymentPointDetailsPage from "./components/payment-point/payment-point-details";
import ManageProductStoreForm from "./components/product/product-manage-store";
import { Permissions } from "./utils/Permissions/Permissions";
import OrderForm from "./components/order/order-update";
import Chat from "./pages/chat/Chat";
import SlicePage from "./pages/slice";
import SliceForm from "./components/slice/slice-form";
import SliceDetailesPage from "./components/slice/slice-details";
import PrizePage from "./pages/prize";
import PrizeForm from "./components/prize/prize-form";
import PrizeDetailesPage from "./components/prize/prize-details";
import ReportPage from "./pages/report";
import OrderShortPage from "./pages/order-short";
import RewardPage from "./pages/reward";
import RewardForm from "./components/reward/reward-form";
import RewardDetailesPage from "./components/reward/reward-details";
import StoreJoinRequestPage from "./pages/store-join-request";
import ProductPage from "./pages/product";
import TrademarkManagerPage from "./pages/trademark-manager";
import TrademarkManagerForm from "./components/trademark-manager/trademark-manager-form";
import BannerCategoryPage from "./pages/banner/banner-category";
import BannerCategoryForm from "./components/banner-category/banner-form";
import BannerCategoryDetailesPage from "./components/banner-category/banner-details";
import BannerTrademarkPage from "./pages/banner/banner-trademark";
import BannerTrademarkForm from "./components/banner-trademark/banner-form";
import BannerTrademarkDetailesPage from "./components/banner-trademark/banner-details";
import HomeePageSectionsArrangementPage from "./pages/arrange-sections-page-home";
import HomePageSectionsArrangementForm from "./components/arrange_sections_page_home/form";
import TrademarkStaticsPage from "./pages/partner";
import TrademarkManagerDetailesPage from "./components/trademark-manager/trademark-manager-details";
import AppsPage from "./components/apps/apps_table";
import UpdateMessageAppForm from "./components/apps/update-message-app-form";
import CategoryCompaniesPage from "./pages/companies";
import OperationStoreCategoriesPage from "./pages/operation-store-categories";
import OperationStoreCategoriesForm from "./components/operation-store-categories/operation-store-categories-form";
import OperationStoreCategoriesDetailsPage from "./components/operation-store-categories/operation-store-categories-details";
import SectionCompaniesPage from "./pages/companies/section-index";

import {
  FaCog,
  FaMapMarkerAlt,
  FaTags,
  FaGift,
  FaCity,
  FaShieldAlt,
  FaBell,
  FaBoxes,
  FaWarehouse,
  FaCubes,
  FaQuestionCircle,
  FaBuilding,
  FaUserFriends,
  FaBriefcase,
  FaStore,
  FaUsers,
  FaBoxOpen,
  FaList,
  FaClipboardList,
  FaCommentDots,
  FaSearch,
  FaMoneyCheckAlt,
  FaCoins,
  FaAward,
} from "react-icons/fa";
import { RiAppStoreLine } from "react-icons/ri";
import { HiOutlineDocumentReport } from "react-icons/hi";
import OrderRatedPage from "./pages/order-rated";

export interface ICrudRoutes {
  path: string;
  component: React.ReactNode;
}
export interface ISubRoute {
  labelKey: string;
  icon?: JSX.Element;
  path: string;
  permissions: string[];
  component: any;
  crudRoutes?: ICrudRoutes[];
  exact?: boolean;
}

export interface IRoutePartner {
  path: string;
  permissions: string[];
  component: any;
}

export interface IRoute {
  labelKey: string;
  icon: JSX.Element;
  path: string;
  crudRoutes?: ICrudRoutes[];

  hasSubMenus: boolean;
  subMenus?: ISubRoute[];

  permissions: string[];
  component: any;
  exact?: boolean;
}

export const partnerRoutes: IRoutePartner[] = [
  {
    path: "/partner/home",
    permissions: [Permissions.CAN_VIEW_TRADEMARK_STATISTICS],
    component: <TrademarkStaticsPage />,
  },
];

export const routes: IRoute[] = [
  {
    labelKey: "home",
    icon: <FaUserTie />,
    path: "/",
    hasSubMenus: false,
    permissions: [Permissions.CAN_VIEW_HOME_PAGE_TAB],
    component: <Home />,
  },
  {
    labelKey: "report",
    icon: <HiOutlineDocumentReport />,
    path: "/report",
    hasSubMenus: false,
    permissions: [Permissions.CAN_VIEW_REPORTS_TAB],
    component: <ReportPage />,
  },
  {
    labelKey: "setting",
    icon: <FaCog />,
    path: "/",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_SITTINGS],
    component: <Home />,
    subMenus: [
      {
        labelKey: "roles",
        icon: <FaShieldAlt />,
        path: "/roles",
        permissions: [Permissions.CAN_VIEW_ROLES_TAB],
        component: <RolePage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <RoleForm />,
          },
          {
            component: <RoleForm />,
            path: "create",
          },
          {
            component: <RoleDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "areas",
        icon: <FaMapMarkerAlt />,
        path: "/areas",
        permissions: [Permissions.CAN_VIEW_AREAS_TAB],
        component: <AreaPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <AreaForm />,
          },
          {
            component: <AreaForm />,
            path: "create",
          },
          {
            component: <AreaDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      //h
      {
        labelKey: "discount-areas",
        icon: <FaMapMarkerAlt />,
        path: "/discount-areas",
        permissions: [Permissions.CAN_VIEW_DISCOUNT_CODE_AREAS_FILES_TAB],
        component: <DiscountAreaPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <DiscountAreaForm />,
          },
          {
            component: <DiscountAreaForm />,
            path: "create",
          },
          {
            component: <DiscountAreaDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "cities",
        icon: <FaCity />,
        path: "/cities",
        permissions: [Permissions.CAN_VIEW_CITIES_TAB],
        component: <CityPage />,
        crudRoutes: [
          {
            path: "update/:id",

            component: <CityForm />,
          },
          {
            component: <CityForm />,
            path: "create",
          },
          {
            component: <CityDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "driver_classifications",
        icon: <FaUserTie />,
        path: "/driver-classifications",
        permissions: [Permissions.CAN_VIEW_DRIVER_CLASSIFICATIONS_TAB],
        component: <DriverClassificationPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <DriverClassificationForm />,
          },
          {
            component: <DriverClassificationForm />,
            path: "create",
          },
          {
            component: <DriverClassificationDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "skip_reasons",
        icon: <FaClipboardList />,
        path: "/skip-reasons",
        permissions: [Permissions.CAN_VIEW_SKIP_REASONS_TAB],
        component: <SkipReasonPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <SkipReasonForm />,
          },
          {
            component: <SkipReasonForm />,
            path: "create",
          },
          {
            component: <SkipReasonDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "incentives",
        icon: <FaGift />,
        path: "/incentives",
        permissions: [Permissions.CAN_VIEW_INCENTIVES_TAB],
        component: <IncentivePage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <IncentiveForm />,
          },
          {
            component: <IncentiveForm />,
            path: "create",
          },
          {
            component: <IncentiveDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "rewards",
        icon: <FaGift />,
        path: "/rewards",
        permissions: [Permissions.CAN_VIEW_REWARDS_TAB],
        component: <RewardPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <RewardForm />,
          },
          {
            component: <RewardForm />,
            path: "create",
          },
          {
            component: <RewardDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "general_settings",
        icon: <FaCog />,
        path: "/general-settings",
        permissions: [Permissions.CAN_VIEW_GENERAL_SETTINGS_TAB],
        component: <GeneralSettingDetailesPage />,
        crudRoutes: [
          {
            path: "update",
            component: <GeneralSettingForm />,
          },
        ],
      },
      {
        labelKey: "apps",
        icon: <RiAppStoreLine />,
        path: "/apps",
        permissions: [Permissions.CAN_VIEW_APPLICATIONS_TAB],
        component: <AppsPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <UpdateMessageAppForm />,
          },
        ],
      },
      {
        labelKey: "policy_term",
        icon: <FaShieldAlt />,
        path: "/policy-term",
        permissions: [Permissions.CAN_VIEW_TERMS_POLICY_TAB],
        component: <PolicyTermDetailesPage />,
        crudRoutes: [
          {
            path: "update",
            component: <PolicyTermForm />,
          },
        ],
      },
    ],
  },
  {
    labelKey: "general_data",
    icon: <FaHome />,
    path: "/aa",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_GENERAL_DATA],
    component: <Home />,
    subMenus: [
      {
        labelKey: "order_notes",
        icon: <FaClipboardList />,
        path: "/order-note",
        permissions: [Permissions.CAN_VIEW_ORDERS_NOTES_TAB],
        component: <OrderNotePage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <OrderNoteForm />,
          },
          {
            component: <OrderNoteForm />,
            path: "create",
          },
          {
            component: <OrderNoteDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "tags",
        icon: <FaTags />,
        path: "/tags",
        permissions: [Permissions.CAN_VIEW_TAGS_TAB],
        component: <TagPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <TagForm />,
          },
          {
            component: <TagForm />,
            path: "create",
          },
          {
            component: <TagDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "units",
        icon: <FaBoxes />,
        path: "/units",
        permissions: [Permissions.CAN_VIEW_PRODUCT_UNITS_TAB],
        component: <UnitPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <UnitForm />,
          },
          {
            component: <UnitForm />,
            path: "create",
          },
          {
            component: <UnitDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "unit_partitions",
        icon: <FaCubes />,
        path: "/unit-partitions",
        permissions: [Permissions.CAN_VIEW_UNIT_PARTITIONS_TAB],
        component: <UnitPartitionPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <UnitPartitionForm />,
          },
          {
            component: <UnitPartitionForm />,
            path: "create",
          },
          {
            component: <UnitPartitionDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "slices",
        icon: <FaWarehouse />,
        path: "/slices",
        permissions: [Permissions.CAN_VIEW_PRODUCT_SLIDES_TAB],
        component: <SlicePage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <SliceForm />,
          },
          {
            component: <SliceForm />,
            path: "create",
          },
          {
            component: <SliceDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "discount_codes",
        icon: <FaGift />,
        path: "/discount-codes",
        permissions: [Permissions.CAN_VIEW_DISCOUNT_CODES_TAB],
        component: <DiscountCodePage />,
        crudRoutes: [
          {
            component: <DiscountCodeForm />,
            path: "create",
          },
          {
            component: <DiscountCodeDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "commen_questions",
        icon: <FaQuestionCircle />,
        path: "/commen-questions",
        permissions: [Permissions.CAN_VIEW_FQAS_TAB],
        component: <CommenQuestionPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <CommenQuestionForm />,
          },
          {
            component: <CommenQuestionForm />,
            path: "create",
          },
          {
            component: <CommenQuestionDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "operation_store_categories",
        icon: <FaList />,
        path: "/operation-store-categories",
        permissions: [Permissions.CAN_VIEW_OPERATION_STORE_CATEGORIES_TAB],
        component: <OperationStoreCategoriesPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <OperationStoreCategoriesForm />,
          },
          {
            component: <OperationStoreCategoriesForm />,
            path: "create",
          },
          {
            component: <OperationStoreCategoriesDetailsPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },
  {
    labelKey: "application_management",
    icon: <FaHome />,
    path: "/application-management",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_APPS_MANAGE],
    component: <Home />,
    subMenus: [
      {
        labelKey: "home_page_list",
        icon: <FaList />,
        path: "/home-page-list",
        permissions: [Permissions.CAN_VIEW_HOME_PAGE_LISTS_TAB],
        component: <HomePageListPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <HomePageListForm />,
          },
          {
            component: <HomePageListForm />,
            path: "create",
          },
          {
            component: <HomePageListDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "arrange_sections_page_home",
        icon: <FaList />,
        path: "/home-page-arrange",
        permissions: [Permissions.CAN_VIEW_HOME_PAGE_LISTS_TAB],
        component: <HomeePageSectionsArrangementPage />,
        crudRoutes: [
          {
            path: "create",
            component: <HomePageSectionsArrangementForm />,
          },
          {
            path: "update/:id",
            component: <HomePageSectionsArrangementForm />,
          },
          {
            path: ":id/companies/:sortFilter",
            component: <SectionCompaniesPage />,
          },
        ],
      },
      {
        labelKey: "banners_for_categories",
        icon: <FaTags />,
        path: "/banners-categories",
        permissions: [Permissions.CAN_VIEW_CATEGORIES_BANNERS_TAB],
        component: <BannerCategoryPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerCategoryForm />,
          },
          {
            component: <BannerCategoryForm />,
            path: "create",
          },
          {
            component: <BannerCategoryDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "banners_for_trademarks",
        icon: <FaBuilding />,
        path: "/banners-trademarks",
        permissions: [Permissions.CAN_VIEW_TRADEMARK_BANNERS_TAB],
        component: <BannerTrademarkPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerTrademarkForm />,
          },
          {
            component: <BannerTrademarkForm />,
            path: "create",
          },
          {
            component: <BannerTrademarkDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "banners_for_client",
        icon: <FaUserFriends />,
        path: "/banners-client",
        permissions: [Permissions.CAN_VIEW_CLIENT_BANNERS_TAB],
        component: <BannerClientPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <BannerClientForm />,
          },
          {
            component: <BannerClientForm />,
            path: "create",
          },
          {
            component: <BannerClientDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      // {
      //   labelKey: "banners_pharmaceutical",
      //   icon: <FaUserTie />,
      //   path: "/banners-pharmaceutical",
      //   permissions: [Permissions.CAN_VIEW_INVESTOR_BANNERS_TAB],
      //   component: <BannerPharmaticysPage />,
      //   crudRoutes: [
      //     {
      //       path: "update/:id",
      //       component: <BannerPharmatyictsForm />,
      //     },
      //     {
      //       component: <BannerPharmatyictsForm />,
      //       path: "create",
      //     },
      //     {
      //       component: <BannersPharmaceuticalDetailesPage />,
      //       path: "details/:id",
      //     },
      //   ],
      // },
      // {
      //   labelKey: "banners_for_delivery",
      //   icon: <FaUserTie />,
      //   path: "/banners-delivery",
      //   permissions: [Permissions.CAN_VIEW_BANNER],
      //   component: <BannerDeliveryPage />,
      //   crudRoutes: [
      //     {
      //       path: "update/:id",
      //       component: <BannerDeliveryForm />,
      //     },
      //     {
      //       component: <BannerDeliveryForm />,
      //       path: "create",
      //     },
      //     {
      //       component: <BannerDleiveryDetailesPage />,
      //       path: "details/:id",
      //     },
      //   ],
      // },
      {
        labelKey: "generals_notification",
        icon: <FaBell />,
        path: "/general-notification",
        permissions: [Permissions.CAN_VIEW_GENERAL_NOTIFICATIONS_TAB],
        component: <GeneralNotificationPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <GeneralNotificationForm />,
          },
          {
            component: <GeneralNotificationForm />,
            path: "create",
          },
          {
            component: <GeneralNotificationDetailesPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },

  {
    labelKey: "clients_and_pharmacies",
    icon: <FaHome />,
    path: "/client-pharmacies",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_CLIENTS_STORES],
    component: <Home />,
    subMenus: [
      {
        labelKey: "investors",
        icon: <FaBriefcase />,

        path: "/investors",
        permissions: [Permissions.CAN_VIEW_INVESTOR_TAB],
        component: <InvestorPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <InvestorForm />,
          },
          {
            component: <InvestorForm />,
            path: "create",
          },
          {
            component: <InvestorDetailesPage />,
            path: "details/:id",
          },
        ],
      },

      {
        labelKey: "stores",
        icon: <FaStore />,
        path: "/stores",

        permissions: [Permissions.CAN_VIEW_STORES_TAB],
        component: <StorePage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <StoreForm />,
          },
          {
            component: <StoreForm />,
            path: "create",
          },
          {
            component: <StoreDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "stores-join-requests",
        icon: <FaUserTie />,
        path: "/stores-join-requests",

        permissions: [Permissions.CAN_VIEW_JOIN_STORES_REQUEST_TAB],
        component: <StoreJoinRequestPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <StoreForm />,
          },
          {
            component: <StoreForm />,
            path: "create",
          },
          {
            component: <StoreDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "clients",
        icon: <FaUsers />,
        path: "/clients",
        permissions: [Permissions.CAN_VIEW_CLIENTS_TAB],
        component: <ClientPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <ClientForm />,
          },
          {
            component: <ClientForm />,
            path: "create",
          },
          {
            component: <ClientDetailsPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },
  {
    labelKey: "partners_and_companies",
    icon: <FaUserTie />,
    path: "/partners_and_companies",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_ALL_TRADEMARKS],
    component: <Home />,
    subMenus: [
      {
        labelKey: "partners",
        icon: <FaUserTie />,
        path: "/partners",
        permissions: [Permissions.CAN_VIEW_TRADEMARK_MANAGER_TAB],
        component: <TrademarkManagerPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <TrademarkManagerForm />,
          },
          {
            component: <TrademarkManagerForm />,
            path: "create",
          },
          {
            component: <TrademarkManagerDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "trademarks",
        icon: <FaUserTie />,
        path: "/trademarks",
        permissions: [Permissions.CAN_VIEW_TRADEMARK_TAB],
        component: <TrademarkPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <TrademarkForm />,
          },
          {
            component: <TrademarkForm />,
            path: "create",
          },
          {
            component: <TrademarkDetailsPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },
  {
    labelKey: "pharmacy_team",
    icon: <FaHome />,
    path: "/pharmacy-team",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_PHARMACY_TEAM],
    component: <Home />,
    subMenus: [
      {
        labelKey: "users",
        icon: <FaUserTie />,
        path: "/users",

        permissions: [Permissions.CAN_VIEW_USERS_TAB],
        component: <UserPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <UserForm />,
          },
          {
            component: <UserForm />,
            path: "create",
          },
          {
            component: <UserDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "delivery_workers",
        icon: <FaUserTie />,
        path: "/delivery-worker",

        permissions: [Permissions.CAN_VIEW_DRIVERS_TAB],
        component: <DeliveryWorkersPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <DeliveryWorkerForm />,
          },
          {
            component: <DeliveryWorkerForm />,
            path: "create",
          },
          {
            component: <DeliveryWorkerDetailsPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },

  {
    labelKey: "products_and_categories",
    icon: <FaBoxes />,
    path: "/products_and_categories",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_CATEGORIES_PRODUCTS],
    component: <Home />,
    subMenus: [
      {
        labelKey: "products",
        icon: <FaBoxOpen />,

        path: "/products",
        permissions: [Permissions.CAN_VIEW_PRODUCTS_TAB],
        component: <ProductPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <ProductForm />,
          },
          {
            component: <ProductForm />,
            path: "create",
          },
          {
            component: <ManageProductStoreForm />,
            path: "manage-store",
          },
          {
            component: <ProductDetailesPage />,
            path: "details/:id",
          },
        ],
      },

      {
        labelKey: "categories",
        icon: <FaTags />,
        path: "/categories",

        permissions: [Permissions.CAN_VIEW_CATEGORIES_TAB],
        component: <CategoryPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <CategoryForm />,
          },
          {
            component: <CategoryForm />,
            path: "create",
          },
          {
            component: <CategoryDetailsPage />,
            path: "details/:id",
          },
          {
            path: ":id/attributes",
            component: <AttributePage />,
          },
          {
            path: ":id/companies",
            component: <CategoryCompaniesPage />,
          },
        ],
      },
    ],
  },
  {
    labelKey: "clients_service",
    icon: <FaHome />,
    path: "/clients_service",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_ORDER],
    component: <Home />,
    subMenus: [
      {
        labelKey: "orders",
        icon: <FaClipboardList />,
        path: "/orders",
        permissions: [Permissions.CAN_VIEW_ORDERS_TAB],
        component: <OrderPage />,
        crudRoutes: [
          {
            component: <OrderDetailesPage />,
            path: "details/:id",
          },
          {
            component: <OrderForm />,
            path: "update/:id",
          },
          {
            component: <AddProductsToOrderPage />,
            path: "add-products/:orderId",
          },
        ],
      },
      {
        labelKey: "orders_short",
        icon: <FaUserTie />,
        path: "/orders/short",
        permissions: [Permissions.CAN_VIEW_SHORT_ORDERS_TAB],
        component: <OrderShortPage />,
      },
      {
        labelKey: "orders_rated",
        icon: <FaUserTie />,
        path: "/orders/rated",
        permissions: [Permissions.CAN_VIEW_ORDER],
        component: <OrderRatedPage />,
      },
      {
        labelKey: "complaints",
        icon: <FaCommentDots />,
        path: "/complaint",
        permissions: [Permissions.CAN_VIEW_COMPLAINTS_TAB],
        component: <ComplaintPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <ComplaintForm />,
          },
          {
            component: <ComplaintForm />,
            path: "create",
          },
          {
            component: <ComplaintDetailesPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "trips",
        icon: <FaRoute />,
        path: "/trips",
        permissions: [],
        component: <TripPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <TripForm />,
          },
          {
            component: <TripForm />,
            path: "create",
          },
          {
            component: <TripDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "skip_analytics",
        icon: <FaChartBar />,
        path: "/skip-analytics",
        permissions: [Permissions.CAN_VIEW_SKIP_ANALYTICS],
        component: <SkipAnalyticsPage />,
        crudRoutes: [
          {
            component: <DriverHistoryPage />,
            path: "driver/:id",
          },
        ],
      },
      {
        labelKey: "price_audit",
        icon: <FaFileInvoiceDollar />,
        path: "/price-audit",
        permissions: [Permissions.CAN_VIEW_PRICE_AUDIT],
        component: <PriceAuditPage />,
      },
      {
        labelKey: "public_surveillance",
        icon: <FaSearch />,
        path: "/public-surveillance",
        //TODO:permissions
        permissions: [Permissions.CAN_VIEW_GENERAL_MONITORING_TAB],
        component: <PublicSurveillance />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <ComplaintForm />,
          },
          {
            component: <ComplaintForm />,
            path: "create",
          },
          {
            component: <ComplaintDetailesPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },

  {
    labelKey: "financial_statements_genral",
    icon: <FaHome />,
    path: "/financial_statements_general",
    hasSubMenus: true,
    permissions: [Permissions.CAN_VIEW_PAYMENTS_MANAGEMENT],
    component: <Home />,
    subMenus: [
      {
        labelKey: "points",
        icon: <FaCoins />,
        path: "/points",
        permissions: [Permissions.CAN_VIEW_DELIVERY_POINTS_TAB],
        component: <PointPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <PointForm />,
          },
          {
            component: <PointForm />,
            path: "create",
          },
          {
            component: <PointDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "payment_point",
        icon: <FaUserTie />,
        path: "/payment-point",
        permissions: [Permissions.CAN_VIEW_DELIVERY_POINT_PAYMENTS_TAB],
        component: <PaymentPointPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <PaymentPointForm />,
          },
          {
            component: <PaymentPointForm />,
            path: "create",
          },
          {
            component: <PaymentPointDetailsPage />,
            path: "details/:id",
          },
        ],
      },
      {
        labelKey: "payment_delivery_worker",
        icon: <FaMoneyCheckAlt />,
        path: "/payment-delivery-worker",
        permissions: [Permissions.CAN_VIEW_DELIVERY_AGENT_PAYMENTS_TAB],
        component: <PaymentDeliveryWorkerPage />,
        crudRoutes: [
          {
            path: "update/:id",
            component: <PaymentDeliveryWorkerForm />,
          },
          {
            component: <PaymentDeliveryWorkerForm />,
            path: "create",
          },
          {
            component: <PaymentDeliveryWorkerDetailesPage />,
            path: "details/:id",
          },
        ],
      },
    ],
  },
  {
    labelKey: "prize",
    icon: <FaAward />,
    path: "/award",
    hasSubMenus: false,
    permissions: [Permissions.CAN_VIEW_AWARDS_TAB],
    component: <PrizePage />,
    crudRoutes: [
      {
        component: <PrizeForm />,
        path: "create",
      },
      {
        component: <PrizeDetailesPage />,
        path: "details/:id",
      },
    ],
  },

  {
    labelKey: "chat",
    icon: <FaRocketchat />,
    path: "/chat",
    hasSubMenus: false,
    permissions: [Permissions.CAN_VIEW_CHAT_TAB],

    component: <Chat />,
  },
];
